export class RadiologyInstructionModel {
    instruction: string;
    SessionTimeout: string;
}




// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/radiology/radiologyinstructionsdatamodel.ts